import { styled } from '@mui/material';

/**
 * Use this in conjunction with StickyElement to create a container that can have sticky elements inside it.
 * The rule is you should have one StickyElement per StickyContiner, so a page layout might look something like this:
 * - Page
 *   - SitckyContainer
 *     - StickyElement
 *     - Rest
 *   - StickyContainer
 *     - StickyElement
 *
 * This way the bottom sticky element will push the top out of the page when the user scroll down far enough
 * */
export const StickyContainer = styled('div')(() => ({
  position: 'relative',
}));
